import { Box, Stack, Typography } from '@mui/material';

import AddFiles from '@assets/add-files.svg';

const DropHere = () => (
  <Stack
    alignItems="center"
    justifyContent="center"
    spacing={1}
    sx={{ minHeight: 320, p: 3, bgcolor: 'primary.light' }}
  >
    <Box
      component="img"
      src={AddFiles}
      alt="Drop files here"
      sx={{
        width: 128,
        height: 128,
        userSelect: 'none',
        pointerEvents: 'none',
      }}
    />
    <Typography variant="h2" align="center">
      Drop files to upload
    </Typography>
    <Typography variant="body2" align="center" color="text.secondary">
      Release files anywhere in this workspace to add them to the upload tray.
    </Typography>
  </Stack>
);

export default DropHere;
